import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@nautilusbio/nb-design-system/styles/all.css';
import App from './App.tsx';
import styles from './styles/index.module.css';

const rootElement = document.querySelector('#appRoot')!;

rootElement.classList.add(styles.mainAppRoot);

if (!rootElement.innerHTML) {
  const root = createRoot(rootElement);

  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
